import $api from "@/core/services/ApiService";
import { AxiosRequestConfig, AxiosResponse } from "axios";
import {
  BuyCrypto,
  CreateCryptoDeposit,
  CreateWallet,
  SellCrypto,
  WithdrawCrypto,
} from "@/core/services/api/interfaces/manager/Crypto";
import WalletEndpoint from "@/core/services/api/endpoints/manager/WalletEndpoint";

class CryptoEndpoint {
  constructor(public wallets: WalletEndpoint = new WalletEndpoint()) {}

  public createUserCryptoDeposit(
    data: CreateCryptoDeposit
  ): Promise<AxiosResponse> {
    return $api.post("manager/crypto/katbit/deposit", data);
  }

  public sellCrypto(data: SellCrypto): Promise<AxiosResponse> {
    return $api.post("manager/crypto/katbit/exchange/crypto-fiat", data);
  }

  public walletsList(): Promise<AxiosResponse> {
    return $api.get("manager/crypto/wallets");
  }

  public addWallet(data: CreateWallet): Promise<AxiosResponse> {
    return $api.post("manager/crypto/wallets", data);
  }

  public getWalletForUserCryptoDeposit(
    params: AxiosRequestConfig = {}
  ): Promise<AxiosResponse> {
    return $api.get("manager/crypto/katbit/wallet-for-deposit", params);
  }

  public withdrawCrypto(data: WithdrawCrypto): Promise<AxiosResponse> {
    return $api.post("manager/crypto/katbit/withdraw-crypto", data);
  }

  public createFiatCryptoExchange(data: BuyCrypto): Promise<AxiosResponse> {
    return $api.post("manager/crypto/katbit/exchange/fiat-crypto", data);
  }
}

export default CryptoEndpoint;
